import React from 'react'
import {graphql} from "gatsby";
import { Element } from 'react-scroll'
import BackButtons from 'components/common/backbuttons'

import Layout from 'components/layout'
import SEO from 'components/common/seo';

import MainBannerSection from 'components/main/banner'
import MainSpotlightSection from 'components/main/spotlight'
import MainTagsMapSection from 'components/main/tagsmap'
import MainGalleryInstagramSection from 'components/main/instagram'
import MainMapSection from 'components/main/map'
import MainContributionSection from 'components/main/contribution'

const IndexPage = (props) => {
  const {homepage,spotlight,instagram,tagsByPosts} =  props.data
  return(
    <Layout>
      <SEO image={homepage.data.ogimage.localFile.childImageSharp.fixed.src} />
        <Element id="topElements" className="element"/>
        <MainBannerSection fields={homepage.data}/>
        <Element id="tagsmapElements" className="element"/>
        <MainTagsMapSection tagsByPosts={tagsByPosts} />
        <Element id="spotlightsElements" className="element"/>
          {spotlight.edges.map(({ node: post },index) => (
              <>
              <Element key={`${index}`} id={`spotlightsElement${index}`} className="element"/>
              <MainSpotlightSection key={post.id} 
                fields={post.data} 
                slug={post.uid} 
                orientation={index % 2 == 0 ? 'right' : 'left'} />
                <BackButtons backElement={index > 0 ? `spotlightsElement${index-1}` : "tagsmapElements"}/>
              </>
          ))}
        <Element id="mapElements" className="element"/>
        <MainMapSection/>
        <Element id="galleryElements" className="element"/>
        <MainGalleryInstagramSection mediadata={instagram} />
        <Element id="contributionsElements" className="element"/>
        <MainContributionSection />
    </Layout>
  )
}


export default IndexPage

export const query = graphql`
    query IndexQuery {
      homepage: prismicHomepage {
        ...MainBannerSection
      }
      tagsByPosts: allPrismicBlog {
        edges {
          node {
            data {
              tags {
                tag {
                  slug
                  document {
                    data {
                      label
                      area
                    }
                  }
                }
              }
            }
          }
        }
      }
      spotlight: allPrismicBlog(sort: {fields: [data___publishdate], order: DESC}, limit: 3) {
        edges {
          node {
            id
            uid
            data {
              title {
                text
              }
              publishdate(formatString: "DD.MM.YYYY")
              subtitle {
                html
              }
              image {
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 400, quality: 90) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
      instagram:allInstagramContent (
        filter: { type: { eq: "image" } }
        sort: {fields: [created_time], order: DESC},
        limit: 15
      ) {
        edges {
          node {
            created_time
            caption {
                text
            }
            link
            type
            location {
                latitude
                longitude
                name
            }
            localImage{ 
                childImageSharp {
                    fluid(maxHeight: 500, maxWidth: 500 quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
            images {
                standard_resolution {
                    url
                }
            }
          }
        }
      }
    }
  `